<template>
  <div class="BaseTemplate bg-white no-wrap full-width column full-height q-mx-none">
    <BaseTemplateHeader @toggle-layer-drawer="state.isLayerOpen = !state.isLayerOpen" />
    <div class="relative-position flex no-wrap flex-1 overflow-hidden">
      <BaseTemplateLayers
        v-click-outside="handleHideLayer"
        class="BaseTemplate__left-side"
        :class="{ 'BaseTemplate__left-side--hidden': $q.screen.lt.md && !state.isLayerOpen }"
      />
      <BaseTemplateMain class="BaseTemplate__main-side" />
      <BaseTemplateItemSetting class="BaseTemplate__right-side" />
    </div>
  </div>
</template>

<script setup>
import vClickOutside from 'src/shared/directives/ClickOutside'
import useBaseTemplateHook from './BaseTemplateHook'
import BaseTemplateHeader from './components/header/BaseTemplateHeader'
import BaseTemplateLayers from './components/layers/BaseTemplateLayers'
import BaseTemplateItemSetting from './components/setting/BaseTemplateItemSetting'

defineOptions({ name: 'BaseTemplate' })

const { state, handleHideLayer } = useBaseTemplateHook()
</script>

<style lang="sass" scoped>
@import "src/shared/styles/variables.sass"
@import "src/shared/styles/mixins.sass"

.BaseTemplate
  @include element('left-side')
    max-width: 380px
    width: 100%
    @include state-modifier('hidden')
      transform: translateX(-100%)
  @include element('main-side')
    min-width: 755px
  @include element('right-side')
    min-width: 340px
    max-width: 340px
    width: 100%
</style>
